import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '上游新闻“跟帖封神榜”';
const baseUrl = '20201204GTFSB2';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rule',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'apply',
      name: `${baseUrl}-apply`,
      component: () => import('./pages/Apply.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'inviteApply',
      name: `${baseUrl}-inviteApply`,
      component: () => import('./pages/InviteApply.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'invitation-share',
      name: `${baseUrl}-posterShare`,
      component: () => import('./pages/PosterSharePage.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
